export default __webpack_public_path__ + "static/media/trickKeto.b66d0fe8.svg";